import { render, staticRenderFns } from "./ModalEditTree.vue?vue&type=template&id=4b803d6e&scoped=true"
import script from "./ModalEditTree.vue?vue&type=script&lang=js"
export * from "./ModalEditTree.vue?vue&type=script&lang=js"
import style0 from "./ModalEditTree.vue?vue&type=style&index=0&id=4b803d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b803d6e",
  null
  
)

export default component.exports